import { SellerUpdateProfileForm } from "../../components/seller/SellerUpdateProfileForm";

import React from "react";
import Grid from '@mui/material/Grid';
import { useParams } from "react-router-dom";
import { AuthHelper } from '../../utils/auth_helper';


function SellerUpdateProfile() {

  return (
    <div>
      <AuthHelper />

      <div className="tw-px-5 tw-w-96 tw-inline-block tw-justify-center sm:tw-ml-20 tw-text-left">

        <Grid container direction="row" alignItems="center" justifyContent="" >

          <Grid container>
            <Grid item xs={12} sm={12}>
              <span className="tw-p-10 tw-text-3xl"><p>Update Seller Profile</p></span>
            </Grid>
          </Grid>

          <SellerUpdateProfileForm />

        </Grid>

      </div>

    </div>
  );

}


export { SellerUpdateProfile };
